/* This copyToClipboard Utility is necessary for Copy functions for RoundID
 and to be compatible with mobile devices */

const legacyCopy = (text) => {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';

  document.body.appendChild(el);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (isIOS) {
    const range = document.createRange();
    range.selectNodeContents(el);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    el.setSelectionRange(0, 999999);
  } else {
    el.select();
  }

  let success = false;
  try {
    success = document.execCommand('copy');
  } catch (err) {
    console.error('execCommand failed:', err);
  }

  document.body.removeChild(el);

  return success;
};

export const copyToClipboard = (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text).catch((err) => {
      if (legacyCopy(text)) {
        return;
      }

      throw err;
    });
  }

  return legacyCopy(text)
    ? Promise.resolve()
    : Promise.reject(new Error('Clipboard copy failed'));
};
